/* eslint-disable @typescript-eslint/naming-convention */

import type { BodyTypeMessageId } from '@core/Utils/VehicleMappedMessages/BodyTypeMappings.constants';
import { Convertible } from '@gds/Icons/Paths/Convertible';
import { Coupe } from '@gds/Icons/Paths/Coupe';
import { Estate } from '@gds/Icons/Paths/Estate';
import { Hatchback } from '@gds/Icons/Paths/Hatchback';
import { Motorhome } from '@gds/Icons/Paths/Motorhome';
import { MVP } from '@gds/Icons/Paths/MVP';
import { Others } from '@gds/Icons/Paths/Others';
import { Pickup } from '@gds/Icons/Paths/Pickup';
import { Saloon } from '@gds/Icons/Paths/Saloon';
import { Sportscar } from '@gds/Icons/Paths/Sportscar';
import { SUV } from '@gds/Icons/Paths/SUV';
import { Van } from '@gds/Icons/Paths/Van';

export const ICON_MAPPER: Record<BodyTypeMessageId, any> = {
  bus: SUV,
  hatchback: Hatchback,
  convertible: Convertible,
  compact: Hatchback,
  coupe: Coupe,
  estate: Estate,
  family: Estate,
  industrial: Van,
  saloon: Saloon,
  sedan: Saloon,
  sport_tourer: Coupe,
  suv: SUV,
  pickup: Pickup,
  mpv: MVP,
  van: Van,
  sportscar: Sportscar,
  transporter: MVP,
  motorhome: Motorhome,
  smallcar: Hatchback,
  othercar: Others,
};
